// extracted by mini-css-extract-plugin
module.exports = {"spacesListDark":"widget-demo--spacesListDark--1JQ5J","spacesListContainer":"widget-demo--spacesListContainer--34v_j"};